// This file is automatically generated. Do not edit it directly.
import { createClient } from '@supabase/supabase-js';
import type { Database } from './types';
import { collaboratorFunctionFetch } from './collaboratorFunctionFetch';
import { isDemoMode } from '@/lib/demo/demoMode';
import { createDemoSupabaseClient } from '@/lib/demo/demoSupabase';
import { demoStore } from '@/lib/demo/demoLoader';

const SUPABASE_URL = import.meta.env.VITE_SUPABASE_URL;
const SUPABASE_PUBLISHABLE_KEY = import.meta.env.VITE_SUPABASE_PUBLISHABLE_KEY;

// Import the supabase client like this:
// import { supabase } from "@/integrations/supabase/client";

const realSupabase = () => createClient<Database>(SUPABASE_URL, SUPABASE_PUBLISHABLE_KEY, {
  auth: {
    storage: localStorage,
    persistSession: true,
    autoRefreshToken: true,
  },
  global: {
    fetch: collaboratorFunctionFetch,
  },
});

// The public /demo/enrichment page runs against in-memory seed data and never
// reaches the database (see src/lib/demo).
export const supabase: ReturnType<typeof realSupabase> = isDemoMode()
  ? createDemoSupabaseClient(demoStore)
  : realSupabase();
